import { STACK, ApiClient } from '@/Ship';

export default (payload) => {
    return STACK.push(() => {
        return ApiClient.post('/registration', payload); // '/register ', user
    });
};
